import Colors from "../../../theme/colors";

const style = {
  container: {
    backgroundColor: Colors.white,
    borderRadius: "8px",
  },
  search: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  searchInput: {
    width: "50%",
    border: "none",
  },
  tableContainer: {
    marginTop: "1rem",
  },
  tableTitle: {
    color: Colors.mediumBlack,
    fontSize: "1.2rem",
    fontWeight: 500,
  },
  tableInfo: {
    fontSize: "1rem",
  },
  tableHeading: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    marginBottom: "0.5rem",
  },
  notFound: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    marginTop: 150,
  },
  export: {
    marginTop: "1rem",
    display: "flex",
    justifyContent: "flex-end",
  },
  link: {
    fontSize: 12,
    color: "#0000FF",
    marginTop: 20,
    fontWeight: 500,
    cursor: "pointer",
  },
  subTitle: {
    fontWeight: "400",
    fontSize: "8px",
    lineHeight: "20px",
    color: "#171B5E",
  },
  infoLabel: {
    px: "16px",
    py: "4px",
    mr: "12px",
    background: "#F2F2F2",
    borderRadius: "3px",
  },
  TableTitle: {
    fontWeight: "500",
    fontSize: "18px",
    lineHeight: "21px",
    color: "#616161",
    mb: "10px",
    mt: "25px",
  },
  topicHeading: { color: "#171B5E", fontSize: "12px" },
  pagination: {
    display: "flex",
    justifyContent: "center",
    margin: "5px",
  },
  tableHeadCells: {
    // padding: "8px",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
};

export default style;
